/**
 * Store Front Store Configuration
 */

import { combineReducers, configureStore, ThunkDispatch } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';

import { authReducer, partnerReducer, sdkReducer, uiReducer, userReducer } from './slices';

// Combine all reducers
const rootReducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    partner: partnerReducer,
    ui: uiReducer,
    sdk: sdkReducer,
});

// Create store
export const sfStore = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
});

// Type exports
export type SFRootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof sfStore.dispatch & ThunkDispatch<SFRootState, null, AnyAction>;

// Re-export everything from slices for backwards compatibility
export * from './slices';
export * from './types';
